module.exports = __webpack_public_path__ + "assets/images/KYD100.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/KYD100.png
// module id = 1413
// module chunks = 1